<template>
  <div>
    <topbar class="mb-2"/>
    <tablepedidos/>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    topbar: () => import('@/views/app/crm/listagemdepedidos/topbaropcoes'),
    tablepedidos: () => import('@/views/app/crm/listagemdepedidos/tablepedidos')
  },
  computed: {
    ...mapState('pedidos', ['pedidosSelecionados'])
  },
  methods: {
    mostrarState () {
      // console.log('pedidosSelecionados', this.pedidosSelecionados)
    }
  }
}
</script>

<style scoped>
</style>
